import React from 'react';
import PropTypes from 'prop-types';
import Table from "semantic-ui-react/dist/es/collections/Table/Table.js";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { getTextAlign } from "./utils/getTextAlign";
export var Component = function Component(_ref) {
  var tableHeadings = _ref.tableHeadings,
      tableBody = _ref.tableBody,
      tableId = _ref.tableId;
  return React.createElement(Table, {
    basic: "very",
    padded: true,
    striped: true
  }, React.createElement(Table.Header, null, React.createElement(Table.Row, null, tableHeadings.map(function (heading, index) {
    return React.createElement(Table.HeaderCell, {
      key: buildKeyFromStrings(tableId, "heading".concat(index)),
      textAlign: getTextAlign(index)
    }, heading);
  }))), React.createElement(Table.Body, null, tableBody.map(function (row, rowIndex) {
    return React.createElement(Table.Row, {
      key: buildKeyFromStrings(tableId, "row".concat(rowIndex))
    }, row.map(function (cell, cellIndex) {
      return React.createElement(Table.Cell, {
        key: buildKeyFromStrings(tableId, "row".concat(rowIndex), "cell".concat(cellIndex)),
        textAlign: getTextAlign(cellIndex)
      }, cell);
    }));
  })));
};
Component.defaultProps = {
  tableId: ''
};
Component.displayName = 'Table';
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  tableBody: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)).isRequired,
  tableHeadings: PropTypes.arrayOf(PropTypes.node).isRequired,
  tableId: PropTypes.string
} : {};